// MAV nav styling + drawer behaviour
// 1. 'SLABS by MAV Luxe' -> gold gradient (site-wide)
// 2. 'Pokemon'           -> blue/yellow neon text glow + Poke Ball icon (header nav only)
// 3. 'Rugby League'      -> green neon text glow + rugby ball icon (header nav only)
// 4. Home page on mobile -> menu drawer opens automatically with 'Cards By MAV' expanded
(function () {
  'use strict';

  // Set to true if you only want the menu to auto-open on the visitor's FIRST
  // page view of the session instead of every time they land on the home page.
  var AUTO_OPEN_ONCE_PER_SESSION = false;

  var ICONS = {
    poke:
      '<svg class="mav-nav-icon mav-nav-icon--poke" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="10" fill="#fafafa" stroke="#111" stroke-width="2.4"/>' +
      '<path d="M2.2 12a9.8 9.8 0 0 1 19.6 0z" fill="#e3350d"/>' +
      '<rect x="2" y="10.7" width="20" height="2.6" fill="#111"/>' +
      '<circle cx="12" cy="12" r="4.2" fill="#fff" stroke="#111" stroke-width="2.4"/>' +
      '<circle cx="12" cy="12" r="1.7" fill="#111"/>' +
      '</svg>',
    rugby:
      '<svg class="mav-nav-icon mav-nav-icon--rugby" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<ellipse cx="12" cy="12" rx="10.2" ry="6.2" transform="rotate(-32 12 12)" fill="#8a4b1f" stroke="#4a260c" stroke-width="1.4"/>' +
      '<path d="M7.9 14.6L16.1 9.4" stroke="#f5e9d6" stroke-width="1.6" stroke-linecap="round"/>' +
      '<path d="M9.1 12.5L10.3 14.6M10.7 11.4L11.9 13.5M12.3 10.3L13.5 12.4M13.9 9.2L15.1 11.3" stroke="#f5e9d6" stroke-width="1.4" stroke-linecap="round"/>' +
      '</svg>'
  };

  // scope: null = anywhere on the page, otherwise limited to the header group
  var RULES = [
    { attr: 'data-mav-gold', test: /slabs\s*by\s*mav\s*luxe/i, max: 40, icon: null, scope: null },
    { attr: 'data-mav-poke', test: /^pok[e\u00e9]mon\b/i, max: 24, icon: 'poke', scope: '#header-group' },
    { attr: 'data-mav-rugby', test: /^rugby\s+league$/i, max: 24, icon: 'rugby', scope: '#header-group' }
  ];

  var SELECTOR = 'summary, button, a, span.menu-list__link-title, .menu-list__label';

  function addIcon(el, kind) {
    if (!kind || !ICONS[kind]) return;
    var host = el.querySelector('.menu-drawer__menu-item-text, .menu-list__link-title, .menu-list__label, span') || el;
    if (host.querySelector('.mav-nav-icon')) return;
    var wrap = document.createElement('span');
    wrap.className = 'mav-nav-icon-wrap';
    wrap.innerHTML = ICONS[kind];
    host.insertBefore(wrap, host.firstChild);
  }

  function applyRule(rule) {
    var roots;
    if (rule.scope) {
      roots = document.querySelectorAll(rule.scope);
      if (!roots.length) return;
    } else {
      roots = [document];
    }

    for (var r = 0; r < roots.length; r++) {
      var nodes = roots[r].querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var txt = (el.textContent || '').trim();
        if (!txt || txt.length > rule.max) continue;
        if (!rule.test.test(txt)) continue;
        el.setAttribute(rule.attr, '');
        var owner = el.closest('summary, button, a') || el;
        owner.setAttribute(rule.attr, '');
        addIcon(owner, rule.icon);
      }
    }
  }

  var painting = false;
  var queued = false;

  function paint() {
    painting = true;
    try {
      for (var i = 0; i < RULES.length; i++) applyRule(RULES[i]);
    } catch (e) {
      /* never let styling break the page */
    }
    painting = false;
  }

  function schedule() {
    if (queued || painting) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      paint();
    });
  }

  // ---------------- auto-open the mobile menu drawer on the home page -------

  function isHomePage() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(window.location.pathname);
  }

  function inDrawerMode() {
    var header = document.querySelector('#header-component');
    var style = header && header.dataset ? header.dataset.menuStyle : null;
    return style === 'drawer' || window.innerWidth < 750;
  }

  function expandCardsByMav() {
    var sums = document.querySelectorAll('#Details-menu-drawer-container summary');
    for (var i = 0; i < sums.length; i++) {
      var s = sums[i];
      var t = (s.textContent || '').trim();
      if (!/^cards\s+by\s+mav/i.test(t)) continue;
      var d = s.closest('details');
      if (d && !d.open) s.click();
      return;
    }
  }

  function autoOpenDrawer() {
    if (window.Shopify && window.Shopify.designMode) return; // never in the theme editor
    if (!isHomePage()) return;

    if (AUTO_OPEN_ONCE_PER_SESSION) {
      try {
        if (window.sessionStorage.getItem('mavMenuAutoOpened')) return;
        window.sessionStorage.setItem('mavMenuAutoOpened', '1');
      } catch (e) {
        /* private mode - just carry on */
      }
    }

    var tries = 0;
    (function attempt() {
      tries++;
      var details = document.getElementById('Details-menu-drawer-container');
      var summary = details ? details.querySelector('summary.header__icon--menu') : null;

      if (details && summary && summary.offsetParent !== null && inDrawerMode()) {
        if (!details.open) summary.click();
        window.setTimeout(function () {
          expandCardsByMav();
          paint();
        }, 420);
        return;
      }
      if (tries < 40) window.setTimeout(attempt, 150);
    })();
  }

  function boot() {
    paint();
    window.setTimeout(autoOpenDrawer, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Drawer contents mount late and re-render when opened
  document.addEventListener('click', function () { window.setTimeout(schedule, 60); }, true);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
